// extracted by mini-css-extract-plugin
export var wrapper = "section-additional-information-module--wrapper--3pNTn";
export var body = "section-additional-information-module--body--1IUZO";
export var cardsWrapper = "section-additional-information-module--cards-wrapper--2OwhV";